"use strict";

exports.__esModule = true;
exports.default = void 0;
const schema = {
  Id: {
    displayName: 'ID',
    type: 'String',
    sortable: true,
    filterable: true
  },
  LanguageId: {
    displayName: 'Language',
    type: 'Relation',
    expanded: 'Language',
    entity: {
      foreign: 'Language',
      getDisplayName: entity => `${entity.DisplayName}`
    },
    guarded: true,
    sortable: true,
    filterable: false
  },
  Category: {
    displayName: 'Category',
    type: 'String',
    value: '',
    // guarded: true,
    sortable: true,
    filterable: true
  },
  Value: {
    displayName: 'Text',
    type: 'String',
    value: '',
    sortable: true,
    filterable: true
  },
  Comment: {
    displayName: 'Comment',
    type: 'String',
    value: '',
    sortable: true,
    filterable: true
  },
  TranslationId: {
    displayName: 'ID',
    type: 'String',
    value: '',
    // guarded: true,
    sortable: true,
    filterable: true
  }
};
var _default = exports.default = schema;
module.exports = exports.default;